import React from "react";
import { useParams } from "react-router-dom";
import { useTimesheetDetail } from "../../hooks/useTimesheetDetail";
import { useAuth } from "../../context/authcontext";
import TimesheetDetailView from "./TimesheetDetailView";

function TimesheetDetailContainer(props) {
    const hookProps = useTimesheetDetail();
    const { auth } = useAuth();
    return <TimesheetDetailView {...hookProps} {...props} auth={auth} />;
}

export default TimesheetDetailContainer;
